/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { VariantResponse } from "./useVariations";

export const getAvailableColours = (
  variants: VariantResponse | undefined,
  selectedSize: string | undefined
) => {
  if (!variants) {
    return [];
  }
  if (!selectedSize) {
    return [];
  }

  return variants?.variants
    .filter((variant) => {
      return variant.dimensions[0].value === selectedSize;
    })
    .map((x) => {
      return {
        ...x.dimensions[1],
      };
    });
};
